import {i18n} from '@online-offer/i18n';
import {DataColumn, SectionPrint} from '@online-offer/shared';
import {Grid, GridItem, Show, Text, VStack} from 'platform/foundation';
import {useLocale} from 'platform/locale';

import {isNotNil} from 'ramda';

import {useGetOnlineOfferData} from '../../hooks/useGetOnlineOfferData';
import {canShowWarranty} from './utils/canShowWarranty';
import {getWarrantyTermsForLanguage} from './utils/getWarrantyTermsForLanguage';

export function WarrantyPrint() {
  const {warrantyDuration, warrantyTermsAndConditions} = useGetOnlineOfferData();
  const {language} = useLocale();
  const termsText = getWarrantyTermsForLanguage(warrantyTermsAndConditions, language);

  return (
    <Show when={canShowWarranty(warrantyDuration, termsText)}>
      <SectionPrint heading={i18n.t('warranty.heading')}>
        <VStack spacing={4}>
          <Show when={isNotNil(warrantyDuration)}>
            <Grid columns={2} spacing={8}>
              <GridItem>
                <DataColumn
                  data={[
                    {
                      label: i18n.t('warranty.defaultDuration'),
                      value: warrantyDuration,
                    },
                  ]}
                />
              </GridItem>
            </Grid>
          </Show>
          <Show when={isNotNil(termsText)}>
            <Text size="base" color="secondary" overflowWrap="anywhere" preWrap>
              {termsText}
            </Text>
          </Show>
        </VStack>
      </SectionPrint>
    </Show>
  );
}
